import { createMuiTheme } from '@material-ui/core/styles';

//colors
const colors = {
  white: '#ffffff',
  primary: '#3660EA',
  secondary: '#1134A9',
  brand: '#151B2B',
  light: '#efefef',
  borderGrey: '#cccccc',
  textGrey: '#404040',
  errorText: 'rgb(97, 26, 21)',
  errorBackground: 'rgb(253, 236, 234)',
  loaderBackdrop: 'rgba(0, 0, 0, 0.1)'
};

//spacing
const space = {
  sm: '8px',
  md: '16px',
  lg: '32px'
};

//constant/fixed values
const fixed = {
  headerHeight: '70'
};

//effects
const effects = {
  boxShadow: '0 0 10px 2px rgba(0, 0, 0, 0.1)',
  boxShadowBottom: '0 10px 10px -10px rgba(0, 0, 0, 0.1)',
  boxShadowStepper: '1px 2px 4px rgba(0, 0, 0, 0.18)',
  tableBorder: `solid 1px ${colors.borderGrey}`
};

const typography = {
  body: {
    fontSize: '14px',
    color: colors.textGrey,
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal'
  },
  button: {
    fontSize: '14px',
    color: colors.textGrey,
    fontWeight: 600,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    textTransform: 'none'
  },
  h1: {
    fontSize: '36px',
    color: colors.textGrey,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal'
  },
  h2: {
    fontSize: '32px',
    color: colors.textGrey,
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal'
  },
  h3: {
    fontSize: '28px',
    color: colors.textGrey,
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal'
  },
  h4: {
    fontSize: '20px',
    color: colors.textGrey,
    fontWeight: 600,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal'
  },
  h4Inverse: {
    fontSize: '20px',
    color: colors.light,
    fontWeight: 600,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal'
  },
  h5: {
    fontSize: '16px',
    color: colors.textGrey,
    fontWeight: 600,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal'
  },
  h6: {
    fontSize: '14px',
    color: colors.textGrey,
    fontWeight: 600,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal'
  },
  tooltip: {
    fontSize: '16px',
    color: colors.white,
    fontWeight: 600,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal'
  },
  overline: {
    textTransform: 'uppercase',
    fontWeight: 600,
    fontSize: '0.813rem',
    lineHeight: 1.36153,
    letterSpacing: '0.09375em'
  }
};

const muiTheme = {
  colors,
  space,
  effects,
  fixed,
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 1024,
      lg: 1440,
      xl: 1920
    }
  },
  palette: {
    primary: {
      main: colors.primary
    },
    secondary: {
      main: colors.secondary
    }
  },
  typography: {
    fontFamily: ['Open Sans'].join(','),
    ...typography
  }
};

export default createMuiTheme(muiTheme);
